import * as React from 'react'

const Search2 = (props: { className?: string }) => (
  <svg {...props} width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M10.1691 8.83867L13.7269 12.4133V12.404C13.9017 12.5784 14 12.8151 14 13.062C14 13.3089 13.9017 13.5456 13.7269 13.72C13.5588 13.916 13.3067 14 13.0733 14C12.8398 14 12.597 13.9067 12.4196 13.72L8.84312 10.164C7.91866 10.8173 6.81677 11.2 5.60282 11.2C2.51193 11.2 0 8.68933 0 5.6C0 2.51067 2.51193 0 5.60282 0C8.69371 0 11.2056 2.51067 11.2056 5.6C11.2087 6.76152 10.8461 7.89457 10.1691 8.83867ZM1.21423 5.60005C1.21423 8.01738 3.18456 9.98671 5.60311 9.98671C8.02166 9.98671 9.99199 8.01738 9.99199 5.60005C9.99199 3.18271 8.02166 1.21338 5.60311 1.21338C3.18456 1.21338 1.21423 3.18271 1.21423 5.60005Z'
      fill='#8EA0B2'
    />
  </svg>
)

export default Search2



// WEBPACK FOOTER //
// ./src/components/icons/ui/Search2.tsx